import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { grpAwardReasonAtom } from '@/store/tasksApprovals/detailsDrawer'
import { IField } from '@/types/tasksApprovals'

import AwardReason from './AwardReason'

const Container = ({ item }: { item: IField }) => {
    const [grpAwardReason, setGrpAwardReason] = useAtom<string>(grpAwardReasonAtom)

    const handleChange = (value: string) => {
        setGrpAwardReason(value)
    }

    useEffect(() => {
        if (!grpAwardReason) {
            setGrpAwardReason(item.value as string)
        }
        return () => {
            setGrpAwardReason('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return <AwardReason item={item} reason={grpAwardReason} onChange={handleChange} />
}

export default Container
